const WelcomeBackDots: React.FC = () => (
  <svg
    viewBox="0 0 603 291"
    className="w-full h-full pointer-events-none"
    style={{ zIndex: 0 }}
  >
    <g transform="translate(-257.000000, -5.000000)">
      <circle fill="#7EBEA5" cx="498.5" cy="98.5" r="4.5" />
      <circle fill="#7365FF" cx="556" cy="20" r="6" />
      <circle fillOpacity="0.4" fill="#26295E" cx="347" cy="177" r="6" />
      <circle fill="#7B9DED" cx="479.5" cy="12.5" r="3.5" />
      <circle fill="#7365FF" cx="756.5" cy="81.5" r="3.5" />
      <circle fillOpacity="0.6" fill="#7B9DED" cx="787.5" cy="29.5" r="3.5" />
      <circle fillOpacity="0.6" fill="#7B9DED" cx="735.5" cy="292.5" r="3.5" />
      <circle fillOpacity="0.6" fill="#7365FF" cx="856.5" cy="112.5" r="3.5" />
      <circle fillOpacity="0.6" fill="#7B9DED" cx="827.5" cy="207.5" r="3.5" />
      <circle fill="#26295E" cx="456.5" cy="176.5" r="4.5" />
      <circle fillOpacity="0.6" fill="#7365FF" cx="387.5" cy="77.5" r="3.5" />
      <circle fillOpacity="0.4" fill="#7365FF" cx="260.5" cy="8.5" r="3.5" />
      <circle fillOpacity="0.4" fill="#7EBEA5" cx="364" cy="7" r="2" />
      <circle fillOpacity="0.4" fill="#7B9DED" cx="316" cy="69" r="2" />
      <circle fill="#7B9DED" cx="772" cy="159" r="2" />
      <circle fillOpacity="0.6" fill="#26295E" cx="788" cy="265" r="2" />
      <circle fillOpacity="0.4" fill="#7EBEA5" cx="270" cy="130" r="2" />
      <circle fillOpacity="0.4" fill="#7365FF" cx="294" cy="204" r="2" />
      <circle fillOpacity="0.6" fill="#7B9DED" cx="440" cy="263" r="3" />
      <circle fill="#7365FF" cx="514.5" cy="253.5" r="4.5" />
      <circle fill="#7365FF" cx="748.5" cy="222.5" r="4.5" />
      <circle fillOpacity="0.6" fill="#7EBEA5" cx="393.5" cy="232.5" r="5.5" />
      <circle fill="#7EBEA5" cx="801.5" cy="117.5" r="5.5" />
    </g>
  </svg>
);

export default WelcomeBackDots;
